import { render } from "./SupportTicketsDocs.vue?vue&type=template&id=573365e1"
import script from "./SupportTicketsDocs.vue?vue&type=script&lang=js"
export * from "./SupportTicketsDocs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__